var map = {
	"./default-branding-apac-prod.json": 7182,
	"./default-branding-dev.json": 860,
	"./default-branding-dit.json": 6506,
	"./default-branding-emea-dev.json": 8279,
	"./default-branding-emea-prod.json": 5633,
	"./default-branding-emea-staging.json": 3629,
	"./default-branding-fit.json": 3188,
	"./default-branding-iat.json": 365,
	"./default-branding-ipe.json": 7667,
	"./default-branding-prod.json": 5060,
	"./default-branding-uat.json": 705,
	"local-branding/default-branding-apac-prod.json": 7182,
	"local-branding/default-branding-dev.json": 860,
	"local-branding/default-branding-dit.json": 6506,
	"local-branding/default-branding-emea-dev.json": 8279,
	"local-branding/default-branding-emea-prod.json": 5633,
	"local-branding/default-branding-emea-staging.json": 3629,
	"local-branding/default-branding-fit.json": 3188,
	"local-branding/default-branding-iat.json": 365,
	"local-branding/default-branding-ipe.json": 7667,
	"local-branding/default-branding-prod.json": 5060,
	"local-branding/default-branding-uat.json": 705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 932;